import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { ApiBackend } from "../../../../providers/apibackend";
import { Event } from "../../../../model/Event";
import { Product } from "../../../../model/Product";

type SearchFilterType = {
    raceWeek?: string;
    discipline?: string;
    onlyRaces?: string[];
};

interface ISearchFilter {
    raceWeek?: string;
    discipline?: string;
    onlyRaces?: string[];
}

const PreBookedHoodies = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
    const [events, setEvents] = useState(null as Event[]);
    const [races, setRaces] = useState(null as Product[]);
    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.raceWeek;
        }
    }));

    useEffect(() => {
        let backend = new ApiBackend();
        backend.listEvents().then((res) => {
            setEvents(res);
        });
        backend.listProducts().then((res) => {
            setRaces(res);
        });
    }, []);

    const disciplines = [{ name: "Skidor", value: "ski" }, { name: "Cykel", value: 'bike' }, { name: 'Löpning', value: 'run' }];

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {

        const selRaces = races?.filter(x => searchFilter.raceWeek && x.EventId == searchFilter.raceWeek && x.type == "race");
        return (
            <SearchFilter<SearchFilterType>
                id={"export-prebookedhoodies-filter"}
                filters={{
                    "raceWeek": {
                        id: "filter-raceWeek",
                        type: "GenericSelect",
                        label: "Evenemang",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: events == null ? [] : events.map(x => { return { name: x.name, value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                    "discipline": {
                        id: "filter-discipline",
                        type: "GenericSelect",
                        label: "Diciplin (valfritt)",
                        size: 12,
                        multiple: false,
                        clearable: true,
                        itemDefinition: {
                            items: disciplines == null ? [] : disciplines.map(x => { return { name: x.name, value: x.value } }),
                            itemValueType: "string"
                        }
                    },
                    "onlyRaces": {
                        id: "filter-onlyraces",
                        type: "GenericSelect",
                        label: "Enbart lopp (valfritt)",
                        size: 12,
                        multiple: true,
                        itemDefinition: {
                            items: selRaces == null ? [] : selRaces.map(x => { return { name: x.name + '', value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default PreBookedHoodies;
